export const MOTION_CONFIG = {
  forceMotion: true,
} as const

export function shouldReduceMotion(): boolean {
  return (
    !MOTION_CONFIG.forceMotion &&
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}
